import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Instagram, ArrowUpRight, Navigation, Clock } from 'lucide-react';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-116" data-mp="3h7hfrxfxka2p">
      <path d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.59 2.59 0 0 1-2.59-2.58 2.59 2.59 0 0 1 2.59-2.59c.27 0 .53.04.77.12V9.66a6.84 6.84 0 0 0-.77-.04 5.66 5.66 0 0 0-5.66 5.66 5.66 5.66 0 0 0 5.66 5.66 5.66 5.66 0 0 0 5.66-5.66V8.18a7.46 7.46 0 0 0 4.33 1.38V6.47a4.28 4.28 0 0 1-3.24-.65z" data-id="element-117" data-mp="3cah67cjvgp6u" />
    </svg>;
}
export function FooterSection() {
  return <footer id="contacts" className="w-full bg-zinc-950 text-white pt-24 px-6 md:px-12 lg:px-20 border-t border-white/5" data-id="element-118" data-mp="2thvhrdbao0wa">
      <div className="max-w-7xl mx-auto" data-id="element-119" data-mp="20usigiysnm4z">
        {/* Header */}
        <div className="mb-16" data-id="element-120" data-mp="20sg6qnjmq80d">
          <div className="flex items-center gap-3 mb-4" data-id="element-121" data-mp="1ggzmlcup1m1c">
            <div className="w-2 h-2 bg-[#6B7A4A] rounded-full pulse-dot" data-id="element-122" data-mp="1ggg8k785zhsl" />
            <span className="font-['JetBrains_Mono'] text-xs text-[#6B7A4A] tracking-widest uppercase" data-id="element-123" data-mp="1lei07gjnopfo">
              Контакти / Координати
            </span>
          </div>
          <h2 className="font-['Oswald'] text-5xl md:text-6xl font-bold uppercase tracking-widest" data-id="element-124" data-mp="1v64750oyo2cm">
            Знайдіть нас
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-stretch" data-id="element-125" data-mp="xjyj5wgsftzi">
          {/* Left Column - Contact info blocks */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="lg:col-span-5 space-y-6" data-id="element-126" data-mp="17g9vunkailuh">
            {/* Address */}
            <div className="relative bg-neutral-900/50 border border-white/10 p-6" data-id="element-127" data-mp="nqh2ebf8zhss">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-128" data-mp="is5qzw9b0z8g" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-129" data-mp="wrfab4st49gn" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-130" data-mp="rux400htw327" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-131" data-mp="44kp25o61624" />

              <div className="flex items-start gap-4" data-id="element-132" data-mp="4aleznuirqf">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-133" data-mp="due3defozza2">
                  <MapPin className="w-5 h-5 text-[#6B7A4A]" data-id="element-134" data-mp="92m8wstf19en" />
                </div>
                <div data-id="element-135" data-mp="3hixturkkc5ep">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-136" data-mp="3hi5xvfn205nw">
                    LOC-01 · Адреса
                  </div>
                  <p className="font-['Oswald'] text-lg uppercase tracking-wide text-white leading-snug" data-id="element-137" data-mp="1s1tu2xohi88m">
                    Хмельницький
                    <br data-id="element-138" data-mp="1wtk8pfugfi5u" />
                    вул. Героя України
                    <br data-id="element-139" data-mp="1j1dx8728xzcq" />
                    Володимира Дудченка, 30
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <a href="tel:+380774500450" className="group relative block bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-6" data-id="element-140" data-mp="1nxujswtss5np">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-141" data-mp="21rlu47fcrtkh" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-142" data-mp="26qq593lu81dg" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-143" data-mp="qcq63uutgfr9" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-144" data-mp="vb9vk58mc9od" />

              <div className="flex items-start gap-4" data-id="element-145" data-mp="1alq1b0ozpvw7">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-146" data-mp="1anaualvnp6ry">
                  <Phone className="w-5 h-5 text-[#6B7A4A]" data-id="element-147" data-mp="15t6nq3qaz0re" />
                </div>
                <div className="flex-1" data-id="element-148" data-mp="11tnzaxz9w7jt">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-149" data-mp="wtry16hymu7y">
                    COMMS-01 · Прямий зв'язок
                  </div>
                  <div className="font-['Oswald'] text-2xl font-bold uppercase tracking-wide text-white" data-id="element-150" data-mp="1thpuufxm97hw">
                    +380 77 450 0450
                  </div>
                </div>
                <ArrowUpRight className="w-5 h-5 text-[#6B7A4A] transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-151" data-mp="1khjcafn29hbv" />
              </div>
            </a>

            {/* Working hours */}
            <div className="relative bg-neutral-900/50 border border-white/10 p-6" data-id="element-152" data-mp="45464s2ph6lf">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-153" data-mp="4773xya3o40p" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-154" data-mp="3q4qp35hkb6l2" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-155" data-mp="3v3bpb4wtdq9i" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-156" data-mp="3xirwqgsq604" />

              <div className="flex items-start gap-4" data-id="element-157" data-mp="crp05hrvx5fy">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-158" data-mp="cr5hfyueud0v">
                  <Clock className="w-5 h-5 text-[#6B7A4A]" data-id="element-159" data-mp="hpgpq5524fgz" />
                </div>
                <div className="flex-1" data-id="element-160" data-mp="mqwdw62j723l">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-2 uppercase" data-id="element-161" data-mp="mnrzygz9krzq">
                    TIME-01 · Графік роботи
                  </div>
                  <div className="flex items-baseline justify-between gap-4" data-id="element-162" data-mp="2oj2f125u0h3j">
                    <span className="font-['Oswald'] text-lg uppercase tracking-wide text-white" data-id="element-163" data-mp="2th3xbkvfocdy">
                      Пн — Пт
                    </span>
                    <span className="font-['Oswald'] text-2xl font-bold tracking-wide text-[#A3E635]" data-id="element-164" data-mp="2ggjq5iugnf2a">
                      9:00 — 18:00
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mt-3 pt-3 border-t border-white/10" data-id="element-165" data-mp="2vbg5eg0ot2ov">
                    <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest uppercase" data-id="element-166" data-mp="2qh2h0xkfzvtp">
                      Сб — Нд
                    </span>
                    <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-600 tracking-widest uppercase" data-id="element-167" data-mp="2zeuvjzicazg1">
                      Вихідний
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Instagram CTA */}
            <a href="https://instagram.com/win_code_garage" target="_blank" rel="noopener noreferrer" className="group relative block bg-[#6B7A4A] hover:bg-[#7d8c5a] transition-colors duration-200 p-6" data-id="element-168" data-mp="3n5rzoq3w8sgq">
              <div className="flex items-center gap-4" data-id="element-169" data-mp="alw6l3sfzpnz">
                <div className="p-2.5 bg-zinc-950/30 border border-white/20 shrink-0" data-id="element-170" data-mp="aja0l8l79i7v">
                  <Instagram className="w-5 h-5 text-white" data-id="element-171" data-mp="3sqpsbjrvcsro" />
                </div>
                <div className="flex-1" data-id="element-172" data-mp="1jdbx6yt8jct">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-white/70 tracking-widest mb-1 uppercase" data-id="element-173" data-mp="3j166q6crukt4">
                    Слідкуйте в Instagram
                  </div>
                  <div className="font-['Oswald'] text-xl font-bold uppercase tracking-widest text-white" data-id="element-174" data-mp="3ntzd0ynw217b">
                    @win_code_garage
                  </div>
                </div>
                <ArrowUpRight className="w-6 h-6 text-white transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-175" data-mp="3e2cro9hu6lqu" />
              </div>
            </a>

            {/* TikTok CTA */}
            <a href="https://www.tiktok.com/@wincodegarage" target="_blank" rel="noopener noreferrer" className="group relative block bg-neutral-900/50 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 p-6" data-id="element-176" data-mp="35399r8ueocdx">
              <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#6B7A4A]/40" data-id="element-177" data-mp="3bkkpc1f4glx5" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t border-r border-[#6B7A4A]/40" data-id="element-178" data-mp="31kk4gb1ltxqu" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b border-l border-[#6B7A4A]/40" data-id="element-179" data-mp="2wtu1t5kkc8zu" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#6B7A4A]/40" data-id="element-180" data-mp="2ruqwdk0o80rc" />

              <div className="flex items-center gap-4" data-id="element-181" data-mp="2ntfdryg7sfsn">
                <div className="p-2.5 bg-[#6B7A4A]/10 border border-[#6B7A4A]/20 shrink-0" data-id="element-182" data-mp="2nv06diiyxonv">
                  <TikTokIcon className="w-5 h-5 text-[#6B7A4A]" data-id="element-183" data-mp="2itj53lwko06r" />
                </div>
                <div className="flex-1" data-id="element-184" data-mp="2dwamxlbfbw5i">
                  <div className="font-['JetBrains_Mono'] text-[10px] text-zinc-500 tracking-widest mb-1 uppercase" data-id="element-185" data-mp="tcxfztnwkjs4">
                    Слідкуйте в TikTok
                  </div>
                  <div className="font-['Oswald'] text-xl font-bold uppercase tracking-widest text-white" data-id="element-186" data-mp="ye4nrsq1piys">
                    @wincodegarage
                  </div>
                </div>
                <ArrowUpRight className="w-6 h-6 text-[#6B7A4A] transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-187" data-mp="17c6mg1mb3ziw" />
              </div>
            </a>
          </motion.div>

          {/* Right Column - Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.15,
          ease: 'easeOut'
        }} className="lg:col-span-7" data-id="element-188" data-mp="jmvr4znq6xc5">
            <div className="relative h-full min-h-[400px] bg-neutral-900/50 border border-white/10 overflow-hidden" data-id="element-189" data-mp="lg0j7azc9vrf">
              {/* Tactical corner brackets */}
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-190" data-mp="ugqco814na1z" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-191" data-mp="zfjg17mp9kof" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-192" data-mp="2nzazi0oct5c" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#6B7A4A] z-20 pointer-events-none" data-id="element-193" data-mp="bpysscjik19c" />

              {/* Live Google Map */}
              <iframe title="Win Code Garage на мапі" src="https://www.google.com/maps?q=Хмельницький,+вулиця+Героя+України+Володимира+Дудченка,+30&hl=uk&z=16&output=embed" className="absolute inset-0 w-full h-full border-0" style={{
              filter: 'grayscale(0.4) contrast(1.05) brightness(0.85)'
            }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-194" data-mp="gj1sl2evw6xz" />

              {/* Label overlay */}
              <div className="absolute top-4 left-4 z-20 px-3 py-1.5 bg-zinc-950/80 border border-white/10 font-['JetBrains_Mono'] text-[10px] text-zinc-300 tracking-widest uppercase pointer-events-none" data-id="element-195" data-mp="2ymglxn05j4rd">
                Карта / Win Code Garage
              </div>

              {/* Directions CTA */}
              <a href="https://maps.google.com/?q=Хмельницький+вулиця+Героя+України+Володимира+Дудченка+30" target="_blank" rel="noopener noreferrer" className="absolute bottom-4 right-4 z-20 group flex items-center gap-2 bg-zinc-950 border border-white/10 hover:border-[#6B7A4A] transition-colors duration-200 px-4 py-2.5" data-id="element-196" data-mp="2jyna8de6sme2">
                <Navigation className="w-3.5 h-3.5 text-[#6B7A4A]" data-id="element-197" data-mp="1w9f9twzpm6o2" />
                <span className="font-['JetBrains_Mono'] text-xs text-white tracking-widest uppercase" data-id="element-198" data-mp="20dd6m11kb5dy">
                  Прокласти маршрут
                </span>
              </a>
            </div>
          </motion.div>
        </div>

        {/* Footer bottom strip */}
        <div className="mt-20 pt-8 pb-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-199" data-mp="2f1ggvmmn138k">
          <div className="flex items-center gap-4" data-id="element-200" data-mp="2jzrpju1757p7">
            <span className="font-['Oswald'] text-lg font-bold uppercase tracking-widest text-white" data-id="element-201" data-mp="25bogucvrrhwp">
              Win Code Garage
            </span>
            <span className="font-['JetBrains_Mono'] text-[10px] text-zinc-600 tracking-widest uppercase" data-id="element-202" data-mp="2a8x3apnya83r">
              UNIT-001 / KHM-UA
            </span>
          </div>
          <div className="font-['JetBrains_Mono'] text-xs text-zinc-600 tracking-widest uppercase" data-id="element-203" data-mp="32ruahhkvfa59">
            © {new Date().getFullYear()} Win Code Garage · Усі права захищено
          </div>
        </div>
      </div>
    </footer>;
}